import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/modules/auth/_models/response.model';
import { environment } from 'src/environments/environment';
import { UserDataModel, UserUpdateDTO } from '@modules/auth';
import { map } from 'rxjs/operators';

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class HttpUserProfileService {
  constructor(private http: HttpClient) {
  }

  updateProfile(user: UserUpdateDTO): Observable<ResponseModel<UserDataModel>> {
    return this.http.post<ResponseModel<UserDataModel>>(`${API_USERS_URL}/v1/UserProfile/update-user-profile`, user);
  }

  updateUserProfile({userId, ...user}: UserUpdateDTO, isAdmin = false): Observable<ResponseModel<UserDataModel>> {
    return this.http.post<ResponseModel<UserDataModel>>(`${API_USERS_URL}/v1/UserProfile/admin-update-user-profile`, {
      ...user,
      Admin: isAdmin ? 1 : 3,
    }, {params: {userId}});
  }

  getMyProfile(): Observable<ResponseModel<UserDataModel>> {
    return this.http.get<ResponseModel<UserDataModel & {birthdate: string}>>(`${API_USERS_URL}/v1/UserProfile/get-user-profile`).pipe(
      map((it) => ({
        ...it, data: {
          ...it.data,
          birthDate: it.data?.birthdate,
        },
      })),
    );
  }

  getUserProfileById(userId: number): Observable<ResponseModel<UserDataModel>> {
    return this.http.get<ResponseModel<UserDataModel>>(`${API_USERS_URL}/v1/UserProfile/get-user-profile/${userId}`);
  }

  getAllUsers(params?: {
    PageSize?: string,
    PageNumber?: string,
    SearchKey?: string,
    GroupId?: string,
    OnlineOnly?: string,
  }): Observable<ResponseModel<UserDataModel[]>> {
    return this.http.get<ResponseModel<UserDataModel[]>>(`${API_USERS_URL}/v1/User/get-all-users`, {params});
  }
}
